module.exports = __webpack_public_path__ + "static/media/approval.af15ae9e.svg";